import axios from "@/libs/api.request";
// 获取列表
export const getUnpackList = id => {
  return axios.request({
    url: `/warehouse/b2bUnpack/getUnpackList/${id}`,
    method: "get"
  });
};

export const getSkuVoice = params => {
  return axios.request({
    url: `/warehouse/b2bUnpack/skuVoice`,
    method: "get",
    params
  });
};

export const postUnpack = (id, data) => {
  return axios.request({
    url: `/warehouse/b2bUnpack/unpackOrder/${id}`,
    method: "post",
    data
  });
};

//批量拆包
export const postUnpackBatch = (id, data) => {
  return axios.request({
    url: `/warehouse/b2bUnpack/batchUnpack/${id}`,
    method: "post",
    data,
    isNoMsg: true
  });
};

// 新批量拆包
export const postUnpackBatchNew = data => {
  return axios.request({
    url: `/warehouse/b2bUnpack/unpackBatch`,
    method: "post",
    data
  });
};

// 删除拆包
export const deleteUnpack = data => {
  return axios.request({
    url: `/warehouse/b2bUnpack/delUnpack`,
    data,
    method: "post"
  });
};

// 获取拆包状态
export const getUnpackStatus = id => {
  return axios.request({
    url: `/doubleClearance/getUnpack/${id}`,
    method: "get"
  });
};

// 设置拆包状态
export const postUnpackStatus = data => {
  return axios.request({
    url: `/doubleClearance/unpack/${data.id}`,
    method: "post",
    data
  });
};

// 获取生成中订单
export const getUnpackOrder = params => {
  return axios.request({
    url: `/warehouse/b2bUnpack/getWaitCreateNumber`,
    method: "get",
    params
  });
};
